import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { NavMarker } from 'react-rhumb';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { CustomerPlatformFAQs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/CustomerPlatformFAQs';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { CustomerPlatformMerchCards } from './CustomerPlatformMerchCards';
import { FeatureTableContainer } from '../../containers/FeatureTableContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CRM_SUITE_API_NAMES = ['crm-suite-starter-bundle', 'crm-suite-professional-bundle', 'crm-suite-enterprise-bundle'];
export const CustomerPlatformPage = () => {
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "CUSTOMER_PLATFORM_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "SUITE",
      apiNames: CRM_SUITE_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(PageTitle, {
        "aria-level": 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.customerPlatform.pageTitle"
        })
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.customerPlatform.description"
        })
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CustomerPlatformMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "suite"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(FeatureTableContainer, {
        skuCategoryName: "CRM_SUITE",
        productApiNames: ['crm-suite-starter-bundle', 'crm-suite-professional-bundle', 'crm-suite-enterprise-bundle'],
        screen: "pricing-page-crm-suite"
      })
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "suite"
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "1400",
      children: /*#__PURE__*/_jsx(CustomerPlatformFAQs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "crmsuite-footer",
      screen: "suite",
      apiName: "crm-suite-starter-bundle"
    })]
  });
};